import gql from 'graphql-tag'

export const CREATE_PAPER_FEEDBACK = gql`
  mutation CreatePaperFeedback(
    $firstName: String!
    $lastName: String!
    $email: String!
    $uploads: [String!]!
    $description: String
    $wordCount: Int!
    $paperType: PaperType
    $feedbackTypes: [FeedbackType!]
    $turnAroundTime: TurnAroundTime
    $uploadUuid: ID!
    $emailPDF: Boolean
    $siteURL: String
  ) {
    createPaperFeedback(
      firstName: $firstName
      lastName: $lastName
      email: $email
      uploads: $uploads
      description: $description
      wordCount: $wordCount
      paperType: $paperType
      feedbackTypes: $feedbackTypes
      turnAroundTime: $turnAroundTime
      uploadUuid: $uploadUuid
      emailPDF: $emailPDF
      siteURL: $siteURL
    ) {
      feedbackId
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/Zoho.ts